import Vue from 'vue';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import Swal from 'sweetalert2';
window.Vue = Vue;


Sentry.init({
    dsn: 'https://b2b7155fb6ca4120ab8838ff4c4f9210@sentry.io/1770258',
    integrations: [new Integrations.Vue({Vue, attachProps: true})],
    sampleRate: 0.1,
    whitelistUrls: [
        'www.stellantisandyou.co.uk'
    ]
});

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

let expiredSessionFired = false

window.axios.interceptors.response.use(response => response, error => {
    // 419 error if user has been on the site too long and their CSRF token has expired
    if (typeof error.response !== 'undefined' && typeof error.response.status !== 'undefined' && error.response.status == 419 && expiredSessionFired === false) {
        expiredSessionFired = true;
        Swal.fire({
            title: 'Session has expired',
            html: 'It has been 12 hours since you started browsing and your session has expired. Please refresh the page to start a new session.',
            icon: 'warning'
        })
        .then(event => {
            window.location.reload(false);
        });
    }
    return Promise.reject(error);
});

if (typeof Object.assign != 'function') {
    // Must be writable: true, enumerable: false, configurable: true
    Object.defineProperty(Object, "assign", {
        value: function assign(target, varArgs) { // .length of function is 2
            'use strict';
            if (target == null) { // TypeError if undefined or null
                throw new TypeError('Cannot convert undefined or null to object');
            }

            var to = Object(target);

            for (var index = 1; index < arguments.length; index++) {
                var nextSource = arguments[index];

                if (nextSource != null) { // Skip over if undefined or null
                    for (var nextKey in nextSource) {
                        // Avoid bugs when hasOwnProperty is shadowed
                        if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                            to[nextKey] = nextSource[nextKey];
                        }
                    }
                }
            }
            return to;
        },
        writable: true,
        configurable: true
    });
}


// WEBPACK FOOTER //
// ./resources/assets/js/careers/bootstrap.js